<template>
<v-container  container--fluid grid-list-xl class="px-0">
  <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
    <v-col cols="12" sm="12" md="2">
      <v-text-field
        v-model="search"
        label="Search..."
        prepend-icon="fas fa-search"
        clearable
      >
      </v-text-field>
    </v-col>
    <v-col cols="4" md="1">
    </v-col>
    <v-col cols="6" md="1">
      <div style="display: flex; justify-content: center; align-items: center">
        <v-btn text @click="refresh" v-if="!loading">
          <v-icon color="cyan darken-2">refresh</v-icon>
        </v-btn>
        <div v-if="loading" class="load-3">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
    </v-col>
    <v-col cols="4" sm="4" md="2" >

    </v-col>

    <v-col cols="4" md="2">
      <v-autocomplete
        label="Choose a depot..."
        :items="renderedDepots"
        item-text="name"
        item-value="id"
        v-model="depot_id"
      ></v-autocomplete>
    </v-col>
    <v-col cols="4" md="2">
    </v-col>
    <v-col v-show="depot_id" cols="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
      <v-tooltip top color="secondary">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newSchedule" v-on="on">
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>Create a new run schedule</span>
      </v-tooltip>
    </v-col>
  </v-row>
  <transition name="slide-x-transition">
    <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
  </transition>

    <v-data-table
      :search="search"
      :headers="headers"
      :items="renderedRunsSchedule"
      :items-per-page="12"

    >
      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td v-if="header.text !== 'Actions'"  class="text-center" v-for="(header, index) in headers" :key="index"
                 >
            {{props.item[header.value]}}
          </td>
          <td v-else style="text-align: center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon  color="blue" @click="editRow(props.item)" v-on="on">
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                  delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

  <v-dialog
    v-model="scheduleDialog"
    max-width="1000px"

  >
    <v-card>
      <v-card-title class="justify-center" style="position: relative">
        <h2>{{EditOrCreateSchedule}} Runs Schedule</h2>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-container container--fluid grid-list-xl pb-0>
          <v-form
            ref="form"
            v-model="valid">
            <v-row justify="space-around">
              <v-col cols="6" md="5">
                <v-autocomplete
                  label="Day"
                  :items="selectDays"
                  item-text="name"
                  v-model="editedRunSchedule.day"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.sort_code_suffix"
                              label="Sort Code Suffix"
                              :rules="sortCodeRule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.type"
                              label="Type"
                              :rules="typeRule"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="5">
                <v-autocomplete
                  label="Cutoff Timezone"
                  :items="renderedDateTimeZones"
                  v-model="editedRunSchedule.cutoff_timezone"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row justify="space-around">
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.insert_cutoff_days"
                              label="Insert Cutoff Days"
                              :rules="daysRule"
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.modify_cutoff_days"
                              label="Modify Cutoff Days"
                              :rules="daysRule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.insert_cutoff_hour"
                              label="Insert Cutoff Hour"
                              :rules="hoursRule"
                ></v-text-field>

              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.modify_cutoff_hour"
                              label="Modify Cutoff Hours"
                              :rules="hoursRule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.insert_cutoff_minute"
                              label="Insert Cutoff Minute"
                              :rules="minuteRule"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="5">
                <v-text-field v-model="editedRunSchedule.modify_cutoff_minute"
                              label="Modify Cutoff Minute"
                              :rules="minuteRule"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="3" class="text-center">
                <v-btn
                  text
                  @click="toggleCancel"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-btn
                  text
                  @click="toggleSave"
                  color="blue darken-1"
                  :disabled="!isFilledForm"
                >Save
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="deleteDialog"
    max-width="500px"

  >
    <v-card>
      <v-card-title class="justify-center">
        <h3>ATTENTION</h3>
      </v-card-title>
      <v-card-text class="text-center">
        You are about to delete this run Schedule. This action cannot be undone. <br>
        Are you sure you want to proceed ?
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
        <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>



</v-container>
</template>

<script>
import axios from 'axios';


export default {
  name: "RunSchedule",
  components: {
  },
  data() {
    return {
      tab: 0,
      search: '',
      loading: false,
      reload:false,
      headers: [
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Depot', value: 'depot_name', align: 'center', sortable: true},
        {text: 'Day', value: 'day', align: 'center', sortable: true},
        {text: 'Sort Code Suffix', value: 'sort_code_suffix', align: 'center', sortable: true},
        {text: 'Type', value: 'type', align: 'center', sortable: true},
        {text: 'Cutoff Timezone', value: 'cutoff_timezone', align: 'center', sortable: true},
        {text: 'Insert Cutoff Days', value: 'insert_cutoff_days', align: 'center', sortable: true},
        {text: 'Insert Cutoff Hour', value: 'insert_cutoff_hour', align: 'center', sortable: true},
        {text: 'Insert Cutoff Minute', value: 'insert_cutoff_minute', align: 'center', sortable: true},
        {text: 'Modify Cutoff Days', value: 'modify_cutoff_days', align: 'center', sortable: true},
        {text: 'Modify Cutoff Hour', value: 'modify_cutoff_hour', align: 'center', sortable: true},
        {text: 'Modify Cutoff Minute', value: 'modify_cutoff_minute', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false, width:'8%'}
      ],

      valid:false,
      showDialog:false,
      depot_id: null,
      dateDialog:false,
      date: '2021-11-11',
      scheduleDialog:false,
      toBeDeleted:null,
      deleteDialog:null,
      editedRunSchedule:{
        id:0,
        depot_id:null,
        depot_name:null,
        day:null,
        sort_code_suffix:null,
        type:null,
        cutoff_timezone:'Australia/Sydney',
        insert_cutoff_days: 0,
        insert_cutoff_hour: 0,
        insert_cutoff_minute: 0,
        modify_cutoff_days: 0,
        modify_cutoff_hour: 0,
        modify_cutoff_minute: 0
      },
      defaultRunSchedule:{
        id:0,
        depot_id: null,
        depot_name: null,
        day: null,
        sort_code_suffix: null,
        type: null,
        cutoff_timezone:'Australia/Sydney',
        insert_cutoff_days: 0,
        insert_cutoff_hour: 0,
        insert_cutoff_minute: 0,
        modify_cutoff_days: 0,
        modify_cutoff_hour: 0,
        modify_cutoff_minute: 0
      },
      displayedItem: null,
      selectDays:[
        'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'
      ],
      insertDateDialog:null,
      dateTimeZones:[],
      timer: '',
      isVisible: false,
      EditOrCreateSchedule:'',
      sortCodeRule: [
        v => !!v || 'sort code suffix is required.',
        v => /^[A-Z]?$/.test(v) || 'sort code suffix must be valid (single capital character)'
      ],
      typeRule:[
        v => !!v || 'type is required.',
        v => /^[a-zA-Z0-9]{1,10}$/.test(v) || 'type must be valid (1-10 alphanumeric characters)'
      ],
      daysRule:[
        v => !!v || 'day is required.',
        v => v <= 0 || 'should be less than or equal 0'
      ],
      hoursRule:[
        v => !!v || 'hour is required.',
        v => v >= 0 && v <= 23 || 'should be between 0 and 23'
      ],
      minuteRule:[
        v => !!v || 'minute is required.',
        v => v >= 0 && v <= 59 || 'should be between 0 and 59'
      ],


    }
  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.reload = !this.reload;
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods:{
    toggleCancel(){
      this.scheduleDialog = false;
    },
    deleteRow(item){
      console.log("chao " + item.id);
      this.toBeDeleted = Object.assign({},item);
      this.deleteDialog = true;
    },
    editRow(item){
      this.EditOrCreateSchedule = 'ID ' + item['id'] + ' Edit ';
      this.displayedItem = Object.assign({}, item);
      this.editedRunSchedule = Object.assign({}, this.displayedItem);
      this.editedRunSchedule.depot_id = this.depot_id;
      this.scheduleDialog = true;
    },
    newSchedule(){
      this.EditOrCreateSchedule = 'New';
      this.displayedItem = Object.assign({}, this.defaultRunSchedule);
      this.editedRunSchedule = Object.assign({}, this.defaultRunSchedule);
      this.editedRunSchedule.depot_id = this.depot_id;
      this.scheduleDialog = true;
    },
    toggleDelete(){
      if(this.toBeDeleted){
        axios.delete(process.env.API_URL + '/runs/schedule/' + this.toBeDeleted.id)
          .then((response) => {
            this.toBeDeleted = null;
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Delete successful');
          })
          .catch((error) => {
            if(error.response.status === 403){
              this.$store.commit('displaySnackbar', 'Only manager can delete!');
            }
            this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
          });
        this.deleteDialog = false;
      }
    },
    toggleSave(){
      this.editedRunSchedule.depot_id = this.depot_id;
      let body = this.editedRunSchedule;

      if (!(this.EditOrCreateSchedule === 'New')) {
        axios.post(process.env.API_URL + '/runs/schedule/' + body.id, body)
          .then((response) => {
            this.scheduleDialog = false;
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Changes saved.');
            this.scheduleDialog = false;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        axios.post(process.env.API_URL +  '/runs/schedule', body)
          .then((response) => {
            this.scheduleDialog = false;
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'run schedule created.');
            this.scheduleDialog = false;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    }

  },
  computed:{
    renderedRunsSchedule() {
      if (this.runsSchedule === null || this.runsSchedule === undefined) {
        return [];
      } else {
        // this.dateTimeZones = this.runsSchedule.dateTimeZone;
        return this.runsSchedule;
      }
    },
    renderedDepots(){
      if (this.depots === null || this.depots === undefined) {
        return [];
      } else {
        return this.depots;
      }
    },
    renderedDateTimeZones(){
      if (this.datetimezones === null || this.datetimezones === undefined) {
        return [];
      } else {
        return this.datetimezones;
      }
    },
    isFilledForm(){
      if(this.editedRunSchedule.day === null){
        return false;
      } else if(this.editedRunSchedule.sort_code_suffix === null){
        return false;
      } else if(this.editedRunSchedule.type === null){
        return false;
      } else if(this.editedRunSchedule.cutoff_timezone === null){
        return false;
      } else return true;
    }
  },
  asyncComputed: {
    async runsSchedule() {
      if (this.reload || !this.reload) {
        if (this.depot_id) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/runs/schedule?'  + 'depot_id=' + this.depot_id)
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL +'/depots')
        .then((response) => {
          if (response.status === 200) {
            return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
          } else {
            return [];
          }
        })
        .catch((error) => {
          return [];
        });
    },
    async datetimezones() {
      if (this.reload || !this.reload) {
        if (this.depot_id) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/runs/schedule/datetimezones')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
  }

}
</script>

<style scoped>
>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}


</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Runs/RunSchedule.vue